import { render, staticRenderFns } from "./cglshgz22026.vue?vue&type=template&id=6bfa902e&scoped=true"
import script from "./cglshgz22026.vue?vue&type=script&lang=js"
export * from "./cglshgz22026.vue?vue&type=script&lang=js"
import style0 from "./cglshgz22026.vue?vue&type=style&index=0&id=6bfa902e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfa902e",
  null
  
)

export default component.exports